import { Component } from '@angular/core';
import { ErrorCodeComponent } from '../../../shared/components/error-code/error-code.component';

@Component({
    selector: 'app-page403',
    templateUrl: './page403.component.html',
    styleUrls: ['./page403.component.scss'],
    imports: [ErrorCodeComponent]
})
export class Page403Component {}
